import React from "react";
import { createComponent } from '@lit-labs/react';
import { Footer } from './Footer';
export const GrainFooter = createComponent({
    tagName: 'grain-footer',
    elementClass: Footer,
    react: React,
});
